import { LogoutOutlined } from '@mui/icons-material'

import { onLogout } from '@tabeeb/modules/account/actions'
import { useDispatch } from '@tabeeb/store'
import { ConfirmationDialog, useDialogState, NavbarItem } from '@collaborate-health/uikit'

const LogoutButton: React.FC = () => {
  const dispatch = useDispatch()

  const [open, onOpen, onClose] = useDialogState()

  const handleLogout = () => {
    dispatch(onLogout())
  }

  return (
    <>
      <NavbarItem name='Log out' error icon={<LogoutOutlined />} onClick={onOpen} />
      <ConfirmationDialog
        onCloseDialog={onClose}
        onSubmit={handleLogout}
        isOpen={open}
        title='Are you sure you want to logout?'
        dialogMessage='Logging out will end your current session and you may be required to re-enter your login credentials the next time you access the system'
        cancelButtonText='No'
        submitButtonColor='error'
        submitButtonText='Logout'
      />
    </>
  )
}

export default LogoutButton

